import React, { useState } from "react"
import Icon from "../../icon/icon.component.jsx"


type OwnProps = {
    editMode: boolean,
    success: boolean,
    children: React.ReactNode,
    setEditMode: (boolean) => void
}

const InlineGenericLinkComponent = (props: OwnProps) => { 
    const [hover, setHover] = useState(false) 
    return (
        <a href={"#"} 
            onClick={() => props.setEditMode(!props.editMode)} 
            onMouseEnter={() => setHover(true)} 
            onMouseLeave={() => setHover(false)} 
        > 
            {props.children} 
            {!props.success ?  
                <Icon value={"pencil-alt"} className={"ml-1 " + (!hover ? "text-gray" : "")} /> : 
                <Icon value={"check"} className={"ml-1 " + (!hover ? "text-success short-fade-out" : "")} />
            } 
        </a> 
    )
}
export default InlineGenericLinkComponent


// WEBPACK FOOTER //
// ./src/common/inline-edit/component/InlineGenericLinkComponent.tsx